
<template lang="html">
  <div class="scroll pc">
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide v-for="(item, index) in mainServer" :key="index">
        <img :src="item.bakImg" alt="" class="pc">
        <div class="">
          <div class="">
            <div class="">
              <h1>{{item.title}}</h1>
              <p>{{item.intro}}</p>
            </div>
            <div class="qr-box" :class="{'qr-ctn': item.scanDetail}">
              <div class="" v-if="item.scanDetail">
                <h2>{{item.scanDetail.wx}}</h2>
                <p class="email">邮箱：{{item.scanDetail.email}}</p>
              </div>
              <div class="img-box">
                <img :src="item.qrImg" alt="" @click.stop="previewQr(item.qrImg)">
              </div>
            </div>
            <div class="" v-if="item.typeCt">
              <ul>
                <li v-for="(inItem, inIndex) in item.typeCt" :key="inIndex">
                  <button type="button" name="button">{{inItem.name}}</button>
                </li>
              </ul>
            </div>
            <div class="scan-txt" v-if="item.scanTxt">
              <p>{{item.scanTxt}}</p>
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination"  slot="pagination"></div>
    </swiper>
    <div class="main">
      <div class="top">
        <h1>服务动态</h1>
        <span class="pc">SERVICE DYNAMICS</span>
      </div>
      <!-- <div class="main-content">
        <div class="content-imgbox">
          <img src="~common/pc/images/main_service.png" alt="" class="pc">
        </div>
        <div class="detail lf">
          <div class="top-in">
            <h1>附近教堂</h1>
            <div class="more">
              更多
              <i class="icon iconfont icon-gengduo1"></i>
            </div>
          </div>
          <div class="">
            <ul>
              <li>版本 v 1.1.1 发布上线了 <span>2018-11-02</span> </li>
              <li> 版本 v 1.0.2 发布上线了 <span>2018-09-10</span> </li>
              <li> 版本 v 1.0.1 发布上线了 <span>2018-05-17</span> </li>
              <li> 版本 v 1.0.0 发布上线了 <span>2018-04-15</span> </li>
            </ul>
          </div>
        </div>
      </div> -->
      <div class="main-content" :class="{'reverse': index === 1, 'pb20': index === 1}" v-for="(item, index) in serverActive" :key="index">
        <div class="content-imgbox">
          <img v-lazy="item.img" alt="" class="pc">
        </div>
        <div class="detail" :class="{'lf': index === 0, 'rt': index === 1}">
          <div class="top-in">
            <h1>{{item.title}}</h1>
            <div class="more" v-if="item.more">
              更多
              <i class="icon iconfont icon-gengduo1"></i>
            </div>
          </div>
          <div class="">
            <ul>
              <li v-for="(inItem, inIndex) in item.content" :key="inIndex">{{inItem.item}}<span>{{inItem.date}}</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import serverData from 'common/pc/js/server'
import 'swiper/dist/css/swiper.css'
import 'common/pc/stylus/base.styl'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {mapGetters, mapMutations} from 'vuex'
export default {
  data () {
    return {
      serverActive: null,
      mainServer: null,
      swiperOption: {
        notNextTick: true, // 循环
        loop: true, // 设定初始化时slide的索引
        initialSlide: 0, // 自动播放
        autoplay: true,
        speed: 800,
        // 滑动方向
        direction: 'horizontal',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  created () {
    this.mainServer = serverData.mainServer
    this.serverActive = serverData.serverActive
  },
  methods: {
    // 二维码预览
    previewQr (url) {
      this.setImg(url)
      this.preview(true)
    },
    ...mapMutations({
      preview: 'SET_IS_SHOW',
      setImg: 'SET_IMG_URL'
    })
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    ...mapGetters(['isShow']),
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted () {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    console.log('this is current swiper instance object', this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.flex-reverse
  flex-direction: row-reverse
.swiper-slide
  &>img
    width: 100%
    min-height: 513px
  &>div
    position: absolute
    left: 0
    right: 0
    top: 50%
    transform: translatey(-50%)
    text-align: center
    h1
      font-size: 44px
      color: #fff
    p
      font-size: 24px
      color: #fff
      margin: 15px 0 35px
    .qr-box
      display: flex
      justify-content: center
      align-items: center
      text-align: left
      .img-box
        width: 210px
        height: 210px
        background-color: rgba(255, 255, 255, .3)
        padding: 15px
        img
          width: 180px
          height: 180px
          cursor: pointer
      h2
        font-size: 24px
        color: #fff
      p
        font-size: 18px
        margin: 0
    .qr-ctn
      width: 432px
      height: 167px
      justify-content: space-between
      margin: auto
      margin-bottom: 60px
      padding: 29px
      background-color: rgba(255, 255, 255, .2)
      .img-box
        width: 112px
        height: 112px
        background-color: none
        padding: 0
        img
          width: 112px
          height: 112px
          cursor: pointer
      .email
        margin: 22px 0 12px
    .scan-txt
      font-size: 24px
      color: #fff
    button
      width: 200px
      height: 66px
      border-radius: 66px
      overflow: hidden
      background-color: rgba(255, 255, 255, 0.8)
      color: #007CE5
      font-size: 20px
      cursor: pointer
      margin-bottom: 16px
.main
  width: 1400px
  margin: auto
  padding-top: 50px
  .main-content
    display: flex
    justify-content: space-between
    padding-bottom: 50px
    img
      width: 600px
      height: 360px
  .reverse
    flex-direction: row-reverse
  .top
    position: relative
    padding-left: 20px
    margin-bottom: 15px
    h1
      margin-bottom: 5px
      color: #007CE5
    span
      color: #eee
    &:after
      content: ''
      width: 10px
      height: 22px
      position: absolute
      left: 0
      top: 3px
      background-color: #007CE5
  .detail
    flex: 1
    .top-in
      display: flex
      justify-content: space-between
      align-items: center
      padding-bottom: 20px
      div
        cursor: pointer
        font-size: 16px
        color: #007CE5
        i
          color: #007CE5
          font-size: 15px
    li
      position: relative
      display: flex
      justify-content: space-between
      align-items: center
      color: #333
      font-size: 18px
      padding: 46px 0 13px
      line-height: 1
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      border-bottom: 1px dashed #999
      span
        color: #999
      /* &:after
        content: ''
        width: 100%
        height: 1px
        position: absolute
        left: 0
        bottom: 0
        background-color: #999 */
  .lf
    width: calc(100% - 600px)
    padding-left: 50px
  .rt
    padding-right: 50px
</style>



// WEBPACK FOOTER //
// src/components/pc/server/server.vue